<div class="attr-mosaic" *ngIf="visible"
  [@attractionsSlide]="{ value: '', params: { duration: enterSlideMs } }"
  [class.attr-mosaic--settling]="settling"
  [style.height.px]="revealHeight"
  (click)="bannerClick.emit()">
  <!-- The photo lives in a fixed box that hangs below the frame (height 390, bottom -120), so the
       resting 150px frame lands on the photo's vertical middle and the expanded 270px frame fills to
       the top — the frame's clip does the reveal; the photo never scales or moves. -->
  <div class="attr-mosaic-photo" [style.height.px]="photoHeight" [style.bottom.px]="photoBottom">
    <!-- One photo (or none): plain and full-bleed, no seams to draw. -->
    <app-attraction-image *ngIf="isSinglePhoto" class="attr-mosaic-single"
      [url]="singlePhoto" [alt]="city">
    </app-attraction-image>

    <ng-container *ngIf="!isSinglePhoto">
      <app-attraction-image *ngFor="let slice of slices; trackBy: trackBySlice"
        class="attr-mosaic-slice" [url]="slice.url" [alt]="city"
        [style.left]="slice.left" [style.width]="slice.width" [style.clip-path]="slice.clipPath">
      </app-attraction-image>

      <div *ngFor="let seam of seams; trackBy: trackBySlice" class="attr-mosaic-seam"
        [style.left]="seam.left" [style.width]="seam.width" [style.clip-path]="seam.clipPath"
        aria-hidden="true">
      </div>
    </ng-container>
  </div>

  <div class="attr-mosaic-text">
    <div class="attr-mosaic-copy">
      <!-- The highlight's own title when there is one, so the copy and the photography describe the
           same tour; otherwise the city, which is what every venue showed before. -->
      <div class="attr-mosaic-title" [class.attr-mosaic-title-highlight]="hasHighlight">
        {{ hasHighlight ? highlightTitle : ('attractions.exploreCity' | translate:{ city: city }) }}
      </div>

      <!-- No second line under a titled highlight: the chip carries "there is more behind this", and
           dropping this is what buys the title its second line. The price goes with it — "from €10"
           is the CITY's cheapest, which reads as this tour's own price once the tour is named. -->
      <ng-container *ngIf="!hasHighlight">
        <div class="attr-mosaic-offer" *ngIf="formattedPrice">
          <span class="attr-mosaic-offer-label">
            {{ 'attractions.bannerToursFrom' | translate:{ count: count, price: formattedPrice } }}
          </span>
          <app-attr-icon name="chevron-right" [size]="16"></app-attr-icon>
        </div>
        <div class="attr-mosaic-sub" *ngIf="!formattedPrice">
          {{ 'attractions.bannerSubtitle' | translate }}
        </div>
      </ng-container>
    </div>

    <!-- "and N more", bottom-right. A row sibling of the copy, so it cannot overlap the title's
         second line. aria-hidden because the count is decoration around the banner's own label, and
         the enclosing block is already pointer-events: none — the whole banner is the tap target. -->
    <div class="attr-mosaic-more" *ngIf="showsMoreChip" aria-hidden="true">
      <span>{{ 'attractions.bannerAndMore' | translate:{ count: moreCount } }}</span>
      <app-attr-icon name="chevron-right" [size]="12"></app-attr-icon>
    </div>
  </div>

  <!-- Dismiss control, so the banner isn't a trap once it's open. The circle is only the visual —
       on touch the tap target is the small button inside it, so a near-miss opens the attractions
       list instead of silently dismissing. -->
  <div class="attr-mosaic-close">
    <app-attr-icon name="close" [size]="14"></app-attr-icon>
    <button type="button" class="attr-mosaic-close-hit" (click)="onDismiss($event)"
      [attr.aria-label]="'attractions.close' | translate">
    </button>
  </div>
</div>
